<template>
  <!-- 合同新建/编辑 -->
  <div class="contract-edit">
    <list-page>
      <list-table class="list-table" background-color="#FFF">
        <form-tag label="合同信息"/>
        <form-items ref="editForm" :data="dataDetail" :columns="3">
          <form-item label="合同编号" desc-message="留空自动生成">
            <el-input v-model="dataDetail.contractNumber" placeholder="留空自动生成"/>
          </form-item>
          <form-item label="合同名称" :required="true" name="contractName" error-message="请输入合同名称">
            <el-input v-model="dataDetail.contractName" placeholder="请输入合同名称"/>
          </form-item>
          <form-item label="合同类型" :required="true" name="contractType" error-message="请选择合同类型">
            <el-select v-model="dataDetail.contractType" placeholder="请选择合同类型" style="width: 100%">
              <el-option v-for="(label, value) in contractTypeMap" :key="value" :label="label" :value="Number(value)"/>
            </el-select>
          </form-item>
          <form-item label="客户" :required="true" name="customerId" error-message="请选择客户">
            <customer-select style="width: 100%" v-model="dataDetail.customerId" placeholder="请选择客户"/>
          </form-item>
          <form-item label="负责人(销售)">
            <employee-select v-model="dataDetail.salesId" placeholder="请选择销售人员"/>
          </form-item>
          <form-item label="售后人员">
            <employee-select v-model="dataDetail.supportId" placeholder="请选择售后人员"/>
          </form-item>
          <form-item label="客户联系人">
            <el-input v-model="dataDetail.contactPerson" placeholder="姓 + 称谓"/>
          </form-item>
          <form-item label="客户电话">
            <el-input v-model="dataDetail.contactPhone" placeholder="手机/座机"/>
          </form-item>
          <form-item label="合同金额(元)">
            <el-input-number v-model="dataDetail.amount" :min="0" :precision="2" controls-position="right" style="width: 100%"/>
          </form-item>
          <form-item label="签约日期">
            <el-date-picker v-model="dataDetail.billDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </form-item>
          <form-item label="合同到期日期">
            <el-date-picker v-model="dataDetail.expireDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </form-item>
          <form-item label="备注">
            <el-input v-model="dataDetail.remark" type="textarea" :rows="2" placeholder="备注信息"/>
          </form-item>
        </form-items>

        <form-tag label="合同明细"/>
        <div class="item-table-wrap">
          <product-select-table ref="itemTable" v-model="dataDetail.itemList" :multi="true"
                                @table-select-multi="addProducts" height="auto">
            <yq-table-column label="产品线" prop="productLine" min-width="120rem">
              <template v-slot="{row}">
                {{ row.productLineName || dictName(productLineList, row.productLine) || '—' }}
              </template>
            </yq-table-column>
            <yq-table-column label="版本号" prop="version" min-width="140rem">
              <template v-slot="{row}">
                <el-input v-model="row.version" placeholder="如 V2.5 / 2025企业版" size="small"/>
              </template>
            </yq-table-column>
            <yq-table-column label="用户数" prop="userCount" width="120rem">
              <template v-slot="{row}">
                <el-input-number v-model="row.userCount" :min="0" :step="1" size="small" controls-position="right" style="width: 100%"/>
              </template>
            </yq-table-column>
            <yq-table-column label="开始时间" prop="startDate" width="150rem">
              <template v-slot="{row}">
                <el-date-picker v-model="row.startDate" type="date" value-format="YYYY-MM-DD" placeholder="开始时间" size="small" style="width: 100%"/>
              </template>
            </yq-table-column>
            <!-- 部署方式仅软件商品(5)可选 -->
            <yq-table-column label="部署方式" prop="publishType" width="140rem">
              <template v-slot="{row}">
                <el-select v-if="isSoftware(row)" v-model="row.publishType" placeholder="请选择" size="small" style="width: 100%">
                  <el-option v-for="t in publishTypeList" :key="t.value" :label="t.label" :value="t.value"/>
                </el-select>
                <span v-else class="muted">—</span>
              </template>
            </yq-table-column>
            <!-- 到期时间仅软件(5)/服务(2)/云服务器(7)可填；不填表示不过期 -->
            <yq-table-column label="到期时间" prop="expireDate" width="160rem">
              <template v-slot="{row}">
                <el-date-picker v-if="canExpire(row)" v-model="row.expireDate" type="date" value-format="YYYY-MM-DD"
                                placeholder="留空表示不过期" size="small" style="width: 100%"/>
                <span v-else class="muted">不过期</span>
              </template>
            </yq-table-column>
            <yq-table-column label="销售金额(元)" prop="amount" width="130rem">
              <template v-slot="{row}">
                <el-input-number v-model="row.amount" :min="0" :precision="2" size="small" controls-position="right"
                                 style="width: 100%" @change="calcItemProfit(row)"/>
              </template>
            </yq-table-column>
            <yq-table-column label="成本金额(元)" prop="cost" width="130rem">
              <template v-slot="{row}">
                <el-input-number v-model="row.cost" :min="0" :precision="2" size="small" controls-position="right"
                                 style="width: 100%" @change="calcItemProfit(row)"/>
              </template>
            </yq-table-column>
            <yq-table-column label="毛利(元)" prop="profit" width="120rem">
              <template v-slot="{row}">
                <el-input :model-value="fmtMoney(row.profit)" disabled size="small"/>
              </template>
            </yq-table-column>
            <yq-table-column label="续费金额(元)" prop="renewAmount" width="130rem">
              <template v-slot="{row}">
                <el-input-number v-model="row.renewAmount" :min="0" :precision="2" size="small" controls-position="right"
                                 style="width: 100%" @change="calcRenewProfit(row)"/>
              </template>
            </yq-table-column>
            <yq-table-column label="续费成本(元)" prop="renewCost" width="130rem">
              <template v-slot="{row}">
                <el-input-number v-model="row.renewCost" :min="0" :precision="2" size="small" controls-position="right"
                                 style="width: 100%" @change="calcRenewProfit(row)"/>
              </template>
            </yq-table-column>
            <yq-table-column label="续费毛利(元)" prop="renewProfit" width="130rem">
              <template v-slot="{row}">
                <el-input :model-value="fmtMoney(row.renewProfit)" disabled size="small"/>
              </template>
            </yq-table-column>
            <yq-table-column label="操作" prop="options" align="center" width="110rem">
              <template #header>
                <table-button type="write" @click="openProductSelect">选择商品</table-button>
              </template>
              <template v-slot="{row, $index}">
                <table-button el-type="danger" @click="removeItem($index)">移除</table-button>
              </template>
            </yq-table-column>
          </product-select-table>
        </div>
      </list-table>

      <form-page :show-page="false">
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
        <page-button @click="goBack">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import CustomerSelect from "@/components/h5/partner/CustomerSelect.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import contractApi from "@/api/dz-crm/partner/contractApi";

const CONTRACT_TYPE_MAP = {1: "框架协议", 2: "销售合同", 3: "代理协议", 4: "服务合同"};
const PUBLISH_TYPE_LIST = [{value: 1, label: "云服务器部署"}, {value: 2, label: "本地部署"}];
// 商品类型：2服务 5软件 7云服务器（可填到期时间）；5软件可选部署方式
const PRODUCT_TYPE_SERVICE = 2;
const PRODUCT_TYPE_SOFTWARE = 5;
const PRODUCT_TYPE_CLOUD_SERVER = 7;

const emptyDetail = () => ({
  id: "", contractNumber: "", contractName: "", contractType: 2,
  customerId: "", salesId: "", supportId: "", contactPerson: "", contactPhone: "",
  billDate: "", expireDate: "", amount: 0, remark: "",
  contractStatus: 100, itemList: [],
});

export default {
  setup() {
    return {router: useRouter(), route: useRoute()};
  },
  name: "ContractEdit",
  components: {
    ProductSelectTable, CustomerSelect, EmployeeSelect, TableButton, PageButton, FormItems, FormItem, FormTag,
    YqTableColumn, FormPage, ListTable, ListPage,
  },
  data() {
    return {
      dataDetail: emptyDetail(),
      contractTypeMap: CONTRACT_TYPE_MAP,
      publishTypeList: PUBLISH_TYPE_LIST,
      productLineList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) {
      commonApi.queryDictionaryList("CRM_PRODUCT_LINE").then(list => this.productLineList = list || []);
      if (this.route.query.id) {
        this.findById(this.route.query.id);
      }
    }
    // 从客户详情「新建合同」进来时带上客户
    if (!this.route.query.id && this.route.query.customerId) {
      this.dataDetail.customerId = this.route.query.customerId;
    }
  },
  methods: {
    /** 合同明细「操作」列表头按钮：打开商品选择弹窗 */
    openProductSelect() {
      if (this.$refs.itemTable) {
        this.$refs.itemTable.toSelectMore();
      }
    },
    findById(id) {
      contractApi.findById(id).then(res => {
        if (!res) return;
        const detail = {
          id: res.id,
          contractNumber: res.contractNumber,
          contractName: res.contractName,
          contractType: res.contractType,
          customerId: res.customerId,
          salesId: res.salesId,
          supportId: res.supportId,
          contactPerson: res.contactPerson,
          contactPhone: res.contactPhone,
          billDate: this.dateOnly(res.billDate, ""),
          expireDate: this.dateOnly(res.expireDate, ""),
          amount: res.amount,
          remark: res.remark,
          contractStatus: res.contractStatus,
          itemList: (res.itemList || []).map(item => ({
            ...item,
            skuId: item.productId,
            startDate: this.dateOnly(item.startDate, ""),
            expireDate: this.dateOnly(item.expireDate, ""),
            profit: this.subtractMoney(item.amount, item.cost),
            renewProfit: this.subtractMoney(item.renewAmount, item.renewCost),
          })),
        };
        this.dataDetail = detail;
      });
    },
    // 商品选择回调：组件已把行加入 itemList（skuId/productName），这里补齐合同明细字段
    addProducts(products) {
      const items = this.dataDetail.itemList || [];
      (products || []).forEach(product => {
        // 组件会把选中商品写入对应行（skuId/productName），这里按 skuId 找到该行补齐合同明细字段
        const row = items.find(it => it.skuId === product.id);
        if (!row) return;
        row.productId = product.id;
        row.productType = product.productType;
        row.productLine = product.bankup1;
        row.productLineName = this.dictName(this.productLineList, product.bankup1);
        row.version = row.version || "";
        row.userCount = row.userCount === undefined || row.userCount === null ? 0 : row.userCount;
        // 部署方式仅软件可选；其它类型置空
        row.publishType = product.productType === PRODUCT_TYPE_SOFTWARE ? (row.publishType || 1) : null;
        // 到期时间仅 2/5/7 可填，其它类型强制清空（不参与预警）
        if (!this.canExpire(row)) {
          row.expireDate = "";
        }
        row.amount = row.amount || 0;
        row.cost = row.cost || 0;
        row.renewAmount = row.renewAmount || 0;
        row.renewCost = row.renewCost || 0;
        this.calcItemProfit(row);
        this.calcRenewProfit(row);
      });
      this.$nextTick(() => this.$refs.itemTable && this.$refs.itemTable.refresh());
    },
    removeItem(index) {
      this.dataDetail.itemList.splice(index, 1);
      this.$nextTick(() => this.$refs.itemTable && this.$refs.itemTable.refresh());
    },
    /** 毛利 = 销售金额 - 成本金额（只读，前端展示用；后端保存时会重算） */
    calcItemProfit(row) {
      row.profit = this.subtractMoney(row.amount, row.cost);
    },
    /** 续费毛利 = 续费金额 - 续费成本 */
    calcRenewProfit(row) {
      row.renewProfit = this.subtractMoney(row.renewAmount, row.renewCost);
    },
    subtractMoney(a, b) {
      return Math.round(((Number(a) || 0) - (Number(b) || 0)) * 100) / 100;
    },
    fmtMoney(value) {
      if (value === null || value === undefined || value === "") return "0.00";
      return Number(value).toFixed(2);
    },
    isSoftware(row) {
      return Number(row.productType) === PRODUCT_TYPE_SOFTWARE;
    },
    canExpire(row) {
      const type = Number(row.productType);
      return type === PRODUCT_TYPE_SERVICE || type === PRODUCT_TYPE_SOFTWARE || type === PRODUCT_TYPE_CLOUD_SERVER;
    },
    dictName(list, value) {
      if (!value) return "";
      const d = (list || []).find(x => x.dictCode === value);
      return d ? d.dictName : "";
    },
    saveData() {
      if (this.$refs.editForm && !this.$refs.editForm.validCheck()) {
        return;
      }
      const items = this.dataDetail.itemList || [];
      if (items.length === 0) {
        this.$message.error("请至少添加一条合同明细");
        return;
      }
      for (const item of items) {
        if (!item.productId && !item.skuId) {
          this.$message.error("存在未选择商品的明细行");
          return;
        }
      }
      const payload = {
        ...this.dataDetail,
        amount: Number(this.dataDetail.amount) || 0,
        itemList: items.map(item => ({
          id: item.id,
          productId: item.productId || item.skuId,
          productType: item.productType,
          version: item.version,
          userCount: Number(item.userCount) || 0,
          purchaseType: item.purchaseType,
          deployCloud: item.deployCloud,
          serviceYears: item.serviceYears,
          publishType: this.isSoftware(item) ? item.publishType : null,
          startDate: item.startDate || null,
          expireDate: this.canExpire(item) ? (item.expireDate || null) : null,
          amount: item.amount,
          cost: item.cost,
          profit: item.profit,
          renewAmount: item.renewAmount,
          renewCost: item.renewCost,
          renewProfit: item.renewProfit,
          remark: item.remark,
        })),
      };
      contractApi.save(payload).then(res => {
        this.$message.success("保存成功");
        this.router.push(`/contract/list/detail?id=${res.id}`);
      });
    },
    goBack() {
      this.router.go(-1);
    },
    dateOnly(value, defaultValue) {
      if (!value) return defaultValue;
      return String(value).slice(0, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-edit {
  height: 100%;
  .list-table {
    padding: 10px;
  }
  .item-table-wrap {
    padding: 0 16px 10px;
  }
  .muted {
    color: #909399;
  }
}
</style>
